
export namespace Config {

  // export const userPoolId = (): string => {
  //   if (process.env.REACT_APP_STAGE === "production") {
  //     return ""
  //   } else {
  //     return ""
  //   }
  // }

  // export const clientId = (): string => {
  //   if (process.env.REACT_APP_STAGE === "production") {
  //     return ""
  //   } else {
  //     return ""
  //   }
  // }

  export const credentialsEndpoint = (): string => {
    if (process.env.REACT_APP_STAGE === "production") {
      return "https://auth.turf-app.io"
    } else {
      return "https://kwiat90ywh.execute-api.eu-west-2.amazonaws.com/staging"
    }
  }

  export const apiEndpoint = (): string => {
    if (process.env.REACT_APP_STAGE === "production") {
      return "https://api.turf-app.io"
    } else {
      return "https://corqd9u12f.execute-api.eu-west-2.amazonaws.com/staging"
    }
  }
}
